import React, { useEffect, useState } from 'react';
import { get, set, find, isArray, constant, times } from 'lodash';
import { Box } from '@mui/material';
import { getAllGroups } from 'modules/Tags/_api';
import { IDocumentDetailGrids } from '../Patient/_types';
import { DocumentDetail } from './DocumentDetail';

export const DocumentDetailGrids: React.FC<IDocumentDetailGrids> = ({
  gridLayout,
  documentUids,
  selectDocumentUuid,
  unselectDocumentUuid,
  patientDocuments,
  setIsPrinting,
  setStandardizedPrint,
  setIsExporting,
  requestedDocuments,
  onlyAddTag = false,
  gridLayoutParams,
  replaceDocumentAtIndex,
  setIsDownloadingFromEldax,
  facilities,
}) => {
  const [activeRegisterGroups, setActiveRegisterGroups] = useState<any[]>([]);
  const [gridLayoutUids, setGridLayoutUids] = useState<any>({});

  const setDocumentToGridPosition = (oldUuid: any, newUuid: any, itemKey: any) => {
    const newGridLayoutUids = { ...gridLayoutUids };
    set(newGridLayoutUids, itemKey, newUuid);
    setGridLayoutUids(newGridLayoutUids);
    replaceDocumentAtIndex(newUuid, itemKey);
  };

  const loadDocument = async () => {
    const activeRegisterGroups = await getAllGroups(true);
    if (isArray(activeRegisterGroups)) {
      setActiveRegisterGroups(activeRegisterGroups);
    }
  };
  useEffect(() => {
    loadDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gridFields = times(16, constant(null));

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${gridLayoutParams.y}, minmax(0, 1fr))`,
          gridTemplateRows: `auto auto 1fr`,
          gridColumnGap: '16px',
          gridRowGap: '16px',
        }}
      >
        {gridFields.map((gridField, index) => {
          const uuid = documentUids[index];
          const patientDocument = find(patientDocuments, { uuid });
          const selectingDocumentDisabled = index > gridLayoutParams.lastDocumentPositionIndex + 1;
          return index >= gridLayoutParams.totalAvailableFields ? null : (
            <Box
              sx={{
                display: 'flex',
              }}
              key={uuid ?? index}
            >
              <DocumentDetail
                patientDocument={patientDocument || {}}
                patientDocumentUuid={uuid}
                masterPatientID={get(patientDocument, 'patientEntity.masterPatientID', null)}
                unselectDocumentUuid={unselectDocumentUuid}
                documentUids={documentUids}
                patientDocuments={patientDocuments}
                setDocumentToGridPosition={setDocumentToGridPosition}
                itemKey={index}
                onlyAddTag={onlyAddTag}
                setIsPrinting={setIsPrinting}
                setStandardizedPrint={setStandardizedPrint}
                setIsExporting={setIsExporting}
                requestedDocuments={requestedDocuments}
                activeRegisterGroups={activeRegisterGroups}
                setActiveRegisterGroups={setActiveRegisterGroups}
                gridLayoutParams={gridLayoutParams}
                selectingDocumentDisabled={selectingDocumentDisabled}
                setIsDownloadingFromEldax={setIsDownloadingFromEldax}
                facilities={facilities}
              />
            </Box>
          );
        })}
      </Box>
    </>
  );
};
